import "../style/Team.css"
import { Container, Row, Col } from "react-bootstrap";
import { FaEnvelope, FaPhone, FaWhatsapp } from "react-icons/fa";
import TeamHero from "./images/Team.png";
import Female from "./images/Female.png";
import Male from "./images/Male.png";
//import TeamMembers from "./images/TeamMembers/Brueckner.avif"

const teamMembers = [
  {
    id: 1,
    name: "Imene Hamzaoui",
    title: "Gründerin und Geschäftsführerin",
    image: Female,
    description: "Anästhesie- und Intensivpflegeexperte. Spezialisiert auf Fachkräftevermittlung aus Tunesien.",
    email: "I.hamzaoui@medwayschule.de",
    phone: "+216 51 613 741",
    whatsapp: "+49 15565996044",
  },
  {
    id: 2,
    name: "Sami Amri",
    title: "Gründer und Geschäftsführer",
    image: Male,
    description: "Berufserfahrung in der Krankenpflege. Vermittlung qualifizierter Pflegefachkräfte aus Tunesien.",
    email: "S.amri@medwayschule.de",
    phone: "+216 51 613 741",
    whatsapp: "+49 15565996044",
  },
];

function Team() {
    return (
        <>
            {/* Hero introduction */}
            <div className="team-hero">
                <div>
                    <div style={{ letterSpacing: "3px", color: "#8c1030", fontWeight: 700, marginBottom: "10px" }}>
                        LERNEN SIE UNSER TEAM KENNEN!
                    </div>
                    <h1 style={{ fontSize: "2.6rem", fontWeight: 700, marginBottom: "22px", color: "#111D4B" }}>
                        Unser <span style={{ color: "#111D4B" }}>Team</span>
                    </h1>
                    <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#5a5a5a", marginTop: "18px" }}>
                        Medway Recruitment ist Ihr zuverlässiger Partner für internationale Personalvermittlung im Gesundheitswesen. Wir bringen qualifizierte Pflegefachkräfte mit Kliniken, Krankenhäusern und Pflegeeinrichtungen in Deutschland zusammen effizient, transparent und nachhaltig.
                    </p>
                    <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#5a5a5a" }}>
                        Unser interdisziplinäres Team begleitet den gesamten Rekrutierungsprozess von der Auswahl geeigneter Fachkräfte bis zur erfolgreichen Integration am Arbeitsplatz. Dabei legen wir besonderen Wert auf persönliche Betreuung, Qualität und langfristige Zusammenarbeit.
                    </p>
                    <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#5a5a5a" }}>
                        Gegründet von Imene Hamzaoui und Sami Amri, vereint Medway Recruitment internationale Perspektiven mit einem tiefen Verständnis für die Anforderungen des deutschen Gesundheitssystems. Unsere Erfahrung ermöglicht es uns, passgenaue Lösungen für Arbeitgeber und Fachkräfte zu schaffen und so einen aktiven Beitrag zur Sicherung der Gesundheitsversorgung zu leisten.
                    </p>
                </div>
                <div className="team-hero__image">
                    <img
                        src={TeamHero}
                        alt="Team Hands Together"
                        style={{ width: "100%", height: "auto", borderRadius: "10px", boxShadow: "0 16px 40px rgba(0,0,0,0.12)" }}
                    />
                </div>
            </div>

            <Container style={{ marginTop: "50px", marginBottom: "50px" }}>
                {/* Team Members Grid */}
                <div style={{ marginBottom: "60px" }}>
                    <h3 style={{ textAlign: "center", marginBottom: "50px", fontSize: "2rem", fontWeight: "bold" }}>
                        DIE KÖPFE HINTER
                    </h3>
                    <p style={{ textAlign: "center", maxWidth: "900px", margin: "0 auto 32px", fontSize: "1.05rem", lineHeight: 1.7, color: "#5a5a5a" }}>
                        Medway ist darauf spezialisiert, hochqualifizierte Pflegefachkräfte aus Tunesien nach Deutschland zu vermitteln und so eine hochwertige und zuverlässige Patientenversorgung zu unterstützen. Unser engagiertes Team aus erfahrenen Fachkräften teilt eine gemeinsame Vision: die nachhaltige Stärkung des Gesundheitswesens durch professionelle, verantwortungsvolle und menschliche Personalvermittlung.
                    </p>
                    <Row style={{ justifyContent: "center", gap: "0px", alignItems: "stretch" }}>
                        {teamMembers.map((member) => (
                            <Col
                                lg={6}
                                md={6}
                                xs={12}
                                key={member.id}
                                style={{ marginBottom: "26px", padding: "12px", display: "flex" }}
                            >
                                <div className="team-card">
                                    <div
                                        className="team-card__media"
                                    >
                                        <img
                                            src={member.image}
                                            alt={member.name}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                objectPosition: "center 15%",
                                            }}
                                        />
                                    </div>
                                    <div className="team-card__body">
                                        <div style={{ fontSize: "1rem", color: "#5b6b89", fontWeight: 500, marginBottom: "6px" }}>
                                            {member.title}
                                        </div>
                                        <div style={{ fontSize: "1.6rem", fontWeight: 700, color: "#2f354a", marginBottom: "10px" }}>
                                            {member.name}
                                        </div>
                                        <p style={{ fontSize: "1rem", lineHeight: 1.6, color: "#4a4a4a", marginBottom: "16px" }}>
                                            {member.description}
                                        </p>
                                        <div className="team-card__links">
                                            <a
                                                href={`mailto:${member.email}`}
                                                style={{ display: "flex", alignItems: "center", gap: "10px", color: "#2f4fa3", textDecoration: "none", fontWeight: 600 }}
                                            >
                                                <FaEnvelope size={20} /> {member.email}
                                            </a>
                                            {member.phone && (
                                                <a
                                                    href={`tel:${member.phone.replace(/\s+/g, "")}`}
                                                    style={{ display: "flex", alignItems: "center", gap: "10px", color: "#2f4fa3", textDecoration: "none", fontWeight: 600 }}
                                                >
                                                    <FaPhone size={20} /> {member.phone}
                                                </a>
                                            )}
                                            {member.whatsapp && (
                                                <a
                                                    href={`https://wa.me/${member.whatsapp.replace(/\D/g, "")}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{ display: "flex", alignItems: "center", gap: "10px", color: "#2f4fa3", textDecoration: "none", fontWeight: 600 }}
                                                >
                                                    <FaWhatsapp size={22} /> {member.whatsapp}
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </Container>

            {/* Call-to-action banner */}
            <div className="team-cta">
                <div className="team-cta__inner">
                    <div style={{ fontSize: "1.4rem", marginBottom: "16px", fontWeight: 500 }}>
                        Haben Sie Fragen?
                    </div>
                    <div style={{ fontSize: "1.8rem", fontWeight: 600, marginBottom: "10px", lineHeight: 1.1 }}>
                        Rufen Sie uns an
                    </div>
                    <div style={{ fontSize: "2.4rem", fontWeight: 700, marginBottom: "22px", letterSpacing: "1px" }}>
                        +216 51 613 741
                    </div>
                    <div style={{ fontSize: "1.4rem", lineHeight: 1.6, marginBottom: "28px" }}>
                        Kontaktieren Sie gerne unser Support-Team, um mehr über die von uns angebotenen
                        Dienstleistungen und vielfältigen Angebote für Ihr Unternehmen zu erfahren!
                    </div>
                    <a
                        href="/Kontakt"
                        style={{
                            display: "inline-block",
                            padding: "12px 32px",
                            borderRadius: "32px",
                            border: "2px solid #fff",
                            color: "#fff",
                            textDecoration: "none",
                            fontWeight: 600,
                            fontSize: "1.2rem",
                        }}
                    >
                        Kontakt
                    </a>
                </div>
            </div>
        </>
    )
}
export default Team;
